import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-video-preview',
  templateUrl: './video-preview.component.html',
  styles: ``
})
export class VideoPreviewComponent {
  @Input() videoUrl!: string;
  @Input() title!: string;
  @Output() close = new EventEmitter(false);

}
